import React, { useState, useEffect } from 'react';
import { importMatches } from "../../../api/index.js";
import { checkImportMatches } from "../../../api/index.js";

// import options
import { useDropzone } from 'react-dropzone';
import PasteTableComponent from './utils/PasteTableComponent.js';

import * as XLSX from 'xlsx';

// MUI COMPONENTS
import { Accordion, AccordionSummary, AccordionDetails, Typography, CircularProgress } from '@mui/material';
import Box from '@mui/material/Box';

//CONSTANTS
//basket GF
import {GAME_FACT_BASKET_FAULT, GAME_FACT_BASKET_TECHNICAL,
  GAME_FACT_BASKET_TIMEOUT, GAME_FACT_BASKET_DEFENSIVE_REBOUND, GAME_FACT_BASKET_OFFENSIVE_REBOUND, GAME_FACT_BASKET_SUFFERED_FAULT, 
  GAME_FACT_BASKET_COUNTER, GAME_FACT_BASKET_SUFFERED_COUNTER,
  GAME_FACT_BASKET_DECISIVE_PASS,GAME_FACT_BASKET_TWOPOINTS_SUCCEEDED, GAME_FACT_BASKET_THREEPOINTS_SUCCEEDED, GAME_FACT_BASKET_FREETHROW_SUCCEEDED,
  GAME_FACT_BASKET_TWOPOINTS_TRY, GAME_FACT_BASKET_THREEPOINTS_TRY, GAME_FACT_BASKET_FREETHROW_TRY
  } from '../../Live/gameFact/constants.js';
//soccer GF
import {GAME_FACT_SOCCER_BUT_TRY, GAME_FACT_SOCCER_BUT_SUCCEEDED, GAME_FACT_SOCCER_SHOT, GAME_FACT_SOCCER_PENALTY_TRY, 
  GAME_FACT_SOCCER_PENALTY_SUCCEEDED, GAME_FACT_SOCCER_SHOOTOUTPENALTY_SUCCEEDED, GAME_FACT_SOCCER_SHOOTOUTPENALTY_TRY, GAME_FACT_SOCCER_FAULT,
  GAME_FACT_SOCCER_YELLOWCARD, GAME_FACT_SOCCER_REDCARD } from '../../Live/gameFact/constants.js';
//rugby GF
import {GAME_FACT_ESSAI, GAME_FACT_TRANSFORMATION_SUCCEEDED, GAME_FACT_TRANSFORMATION_TRY, GAME_FACT_SHOOTOUTPENALTY_SUCCEEDED, GAME_FACT_SHOOTOUTPENALTY_TRY,
  GAME_FACT_DROP_SUCCEEDED, GAME_FACT_DROP_TRY, GAME_FACT_PENALITE_SUCCEEDED, GAME_FACT_PENALITE_TRY,
  GAME_FACT_FAULT, GAME_FACT_YELLOWCARD, GAME_FACT_REDCARD } from '../../Live/gameFact/constants.js';
//handball GF
import {GAME_FACT_HANDBALL_GOAL_TRY, GAME_FACT_HANDBALL_GOAL_SUCCEEDED, GAME_FACT_HANDBALL_PENALTY_TRY, GAME_FACT_HANDBALL_PENALTY_SUCCEEDED,
  GAME_FACT_HANDBALL_YELLOWCARD, GAME_FACT_HANDBALL_REDCARD, GAME_FACT_HANDBALL_TWOMIN_SUSPENSION,GAME_FACT_HANDBALL_TIMEOUT, 
  GAME_FACT_HANDBALL_TURNOVER, GAME_FACT_HANDBALL_SHOOTOUT_TRY, GAME_FACT_HANDBALL_SHOOTOUT_SUCCEEDED } from '../../Live/gameFact/constants.js';

//ICONS
import ForwardIcon from '@mui/icons-material/Forward';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import SportsBasketballIcon from '@mui/icons-material/SportsBasketball';
import SportsIcon from '@mui/icons-material/Sports';
import GroupsIcon from '@mui/icons-material/Groups';
import PersonIcon from '@mui/icons-material/Person';
import DoneIcon from '@mui/icons-material/Done';
import UpdateIcon from '@mui/icons-material/Update';
import ErrorIcon from '@mui/icons-material/PriorityHigh';
import InfoIcon from '@mui/icons-material/Info';
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


const dropzoneStyles = {
  border: '2px dashed #ccc',
  borderRadius: '4px',
  padding: '20px',
  textAlign: 'center',
  cursor: 'pointer',
};

const ColumnMappingComponent = ({ commonColumns, gamefactsColumns, requiredColumns, onColumnMappingChange, prevColumnMapping, prevMappedColumns, headerRow, showInfoMsg }) => {
  const [showPlayerAccordion, setShowPlayerAccordion] = useState(false);
  const [columnMappings, setColumnMappings] = useState({});
  const [mappedColumns, setMappedColumns] = useState({});
  const [isMappingValid, setIsMappingValid] = useState(false);

  // Format possible choices from header (removed gamefacts columns)
  // Extract available choices
  const availableChoices = headerRow;

  if (Object.keys(columnMappings).length === 0 && Object.keys(prevColumnMapping).length > 0 && Object.keys(mappedColumns).length === 0 && Object.keys(prevMappedColumns).length > 0){

    setColumnMappings((prevMappings) => ({
      ...prevMappings,
      ...prevColumnMapping
      }));
    
    setMappedColumns((prevMappings) => ({
        ...prevMappings,
        ...prevMappedColumns
        }));
}

  // column mapping validation
  const checkIfMappingValid = (currentMapping) => {
    const sortedUpdatedMappings = Object.fromEntries(Object.entries(currentMapping).sort((a, b) => requiredColumns.indexOf(a[0]) - requiredColumns.indexOf(b[0])));
    const sortedRequiredColumns = requiredColumns.sort();
    const isValid = sortedRequiredColumns.every((column) => sortedUpdatedMappings[column] !== undefined && sortedUpdatedMappings[column] !== null);
    return isValid;
  };

   // UseEffect to trigger validation after state update
   useEffect(() => {
    // Check if all mandatory columns are mapped
    const isValid = checkIfMappingValid(mappedColumns);
    setIsMappingValid(isValid);
  }, [mappedColumns]);


  const handleMappingChange = (columnName, mappedValue) => {

  
    setColumnMappings((prevMappings) => ({
      ...prevMappings,
      [columnName]: mappedValue,
    }));


    setMappedColumns((prevMappings) => {
      const updatedMappings = {
        ...prevMappings,
        [columnName]: headerRow.indexOf(mappedValue),
      };

      // Check if all mandatory columns are mapped
      const isValid = checkIfMappingValid(updatedMappings);
      setIsMappingValid(isValid);
      return updatedMappings;
  });

  };

  const handleApplyMapping = () => {
    
    // If validation is OK, give mapping to parent component
    if (isMappingValid) {
      onColumnMappingChange(columnMappings, mappedColumns, isMappingValid);
      setShowPlayerAccordion(true);
    } else {
      // update validation state
      setIsMappingValid(false);
    }
  };

  // Calculer la largeur maximale des labels
  const maxLabelWidth = Math.max(...commonColumns.map(columnName => columnName.length * 15)); // Ajustez la valeur multiplicatrice selon vos besoins


  return(
    <div>
    <div style={{ marginTop: '30px' }}>
    <h3 style={{ marginBottom: '20px' }}>{'Mapping des compétitions, équipes et joueurs'}</h3>
    {/* Error msg - validation fail */}
    {!isMappingValid && showInfoMsg && (
      <div style={{ color: 'red', marginTop: '10px', marginBottom: '20px' }}>
        Veuillez mapper toutes les colonnes obligatoires avant d'appliquer le mapping.
      </div>
    )}
    {commonColumns.map((columnName, index) => (
      <div key={columnName} style={{ marginBottom: '15px', display: 'flex'}}>
        <label style={{ width: `${maxLabelWidth}px`, marginRight: '60px', display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
          <span>{columnName}
        {requiredColumns.includes(columnName) && <span style={{ color: 'red', padding:'5px' }}>*</span>}</span>
        <ForwardIcon style={{ marginLeft: '5px' }} />
        </label>
        <select
          value={columnMappings[columnName] || ''}
          onChange={(e) => handleMappingChange(columnName, e.target.value)}
          style={{
            width: '50%',
            padding: '8px',
            borderRadius: '5px',
            border: '1px solid #ccc',
            verticalAlign: 'middle'
          }}
        >
          <option value="" disabled>
            Choisir une colonne
          </option>
          {availableChoices.map((header, headerIndex) => (
            <option key={headerIndex} value={header}>
              {header}
            </option>
          ))}
        </select>
      </div>
    ))}
  </div>

  <div style={{ marginTop: '30px' }}>
    <h3 style={{ marginBottom: '20px' }}>{'Mapping des faits de jeux'}</h3>
    {gamefactsColumns.map((columnName, index) => (
      <div key={columnName} style={{ marginBottom: '15px', display: 'flex'}}>
        <label style={{ width: `${maxLabelWidth}px`, marginRight: '60px', display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
          {columnName} <ForwardIcon style={{ marginLeft: '5px' }} />
        </label>
        <select
          value={columnMappings[columnName] || ''}
          onChange={(e) => handleMappingChange(columnName, e.target.value)}
          style={{
            width: '50%',
            padding: '8px',
            borderRadius: '5px',
            border: '1px solid #ccc',
            verticalAlign: 'middle'
          }}
        >
          <option value="" disabled>
            Choisir une colonne
          </option>
          {availableChoices.map((header, headerIndex) => (
            <option key={headerIndex} value={header}>
              {header}
            </option>
          ))}
        </select>
      </div>
    ))}
 
    <button
      onClick={handleApplyMapping}
      disabled={!isMappingValid}
      style={{
        padding: '10px',
        borderRadius: '5px',
        background: isMappingValid ? '#0A76B9' : '#ccc',
        color: 'white',
        cursor: isMappingValid ? 'pointer' : 'not-allowed',
      }}
    >
      Appliquer le mapping
    </button>
  </div>
  </div>
  );
};

const PlayerAccordion = ({ playerData, oddBackground }) => {
  //removed Points, for now
  const { 'Compétition': Competition, Saison, 'Journée': Jour, 'Equipe domicile': HomeTeam, 'Equipe visiteur': AwayTeam, 'Equipe Joueur': PlayerTeam,'Numéro Joueur': NumeroJoueur, 'Nom Joueur': NomJoueur, 'Prénom Joueur': PrenomJoueur, Minutes, gameFacts } = playerData;

  return (<div>
    
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel-content" id="panel-header"  style={{ backgroundColor: oddBackground ? '#d0d0d075' : 'transparent', borderBottom: '2px solid #80808070' }}>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
            {(Competition && <div style={{ paddingRight: '10px', paddingLeft: '10px'}}>
                <strong>Compétition:</strong> {Competition}, Saison {Saison}
              </div>)}
              {(Jour && <div style={{ paddingRight: '10px', paddingLeft: '10px'}}>
                <strong>Journée:</strong> {Jour}
              </div>)}
              {(AwayTeam && <div style={{ paddingRight: '10px', paddingLeft: '10px'}}>
            <strong>Equipes:</strong> {HomeTeam} - {AwayTeam}
          </div>)}
          {PlayerTeam !== undefined && (<div style={{ paddingRight: '10px', paddingLeft: '10px'}}>
            <strong>Equipe:</strong> {PlayerTeam}
          </div>)}
          {NomJoueur !== undefined && (<div style={{ paddingRight: '10px', paddingLeft: '10px'}}>
            <strong>Joueur:</strong> {NumeroJoueur !== undefined ? 'numéro ' + NumeroJoueur + ' ~ ' : ''} {NomJoueur} {PrenomJoueur}
          </div>)}
          {Minutes !== undefined && (<div style={{ paddingRight: '10px', paddingLeft: '10px'}}>
            <strong>Minutes:</strong> {Minutes} 
          </div> )}
          {/*Points !== undefined && ( <div style={{ paddingRight: '10px', paddingLeft: '10px'}}>
            <strong>Points:</strong> {Points}
  </div> )*/}
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <div>
          {Object.entries(gameFacts).map(([factKey, factValue]) => (
            factValue !== undefined && <Typography key={factKey}>
            <Box display="flex" alignItems="center" padding="8px">
              <SportsIcon />
              <span style={{ marginLeft: '8px' }}>{`${factKey}: ${factValue}`}</span>
            </Box>
          </Typography>
          ))}
        </div>
      </AccordionDetails>
    </Accordion>
    </div>
  );
};


const Legend = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <div style={{ display: 'flex', backgroundColor: 'rgb(128 128 128 / 10%)', padding: '20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', padding: '10px', marginBottom: '5px' }}>
          <DoneIcon style={{ color: '#009900', paddingRight: '5px' }} />
          <span>Création</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', padding: '10px', marginBottom: '5px' }}>
          <UpdateIcon style={{ color: '#e69500', paddingRight: '5px' }} />
          <span>Mise à jour</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', padding: '10px', marginBottom: '5px' }}>
          {/*carré couleur : <div style={{ width: '20px', height: '20px', backgroundColor: '#cc0000', marginRight: '5px' }}></div>*/}
          <ErrorIcon style={{ color: '#cc0000' }} />
          <span>Erreur</span>
        </div>
      </div>
    </div>
  );
};

const ImportResume = ({ importSummary }) => {

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        backgroundColor: '#e9e9e9',
        color: 'black',
        border: '1px solid #00000033',
      }}
    >
      <div
        style={{
          display: 'flex',
          padding: '10px',
          marginBottom: '5px',
          alignItems: 'center',
          alignSelf: 'center'
        }}
      >
        <InfoIcon style={{ padding: '5px' }} />
        <span>Détail de l'import pour les Compétitions, équipes, joueurs, matchs et gamefacts importés.</span>
      </div>

      {/* Afficher le résumé de l'importation */}
      {importSummary &&
        Object.entries(importSummary).map(([key, summary]) => (
          <div key={key} style={{ padding: '10px', borderBottom: '1px solid #ccc', alignItems: 'center', textAlign: 'center', color: summary.errorCount > 0 ? 'red' : 'black', /*Rouge si nb erreurs > 0*/ }}>
            <strong style={{padding:'5px'}}>{summary.name}</strong>
            Total: {summary.total}, Succès: {summary.successCount}, Erreurs: {summary.errorCount}
          </div>
        ))}

    </div>
  );
};



const GamefactsAccordionCheckData = ({ playerData, oddBackground }) => {

  const {
    'competitionName': Competition,
    'season' : Saison,
    'day': Jour,
    'homeTeam': HomeTeam,
    'awayTeam': AwayTeam,
    'homeTeamName': HomeTeamName,
    'awayTeamName': AwayTeamName,
    'checkResult' : checkedResult,
    'DBSuccess' : ImportFlag,
    'DBMessage' : ImportErrorMsg,
    'totalGf' : stats,
    gameFacts,
  } = playerData;

  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel-content"
        id="panel-header"
        style={{
          backgroundColor: oddBackground ? '#d0d0d075' : 'transparent',
          borderBottom: '2px solid #80808070',
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <div style={{ paddingRight: '10px', display:'flex', alignItems:'center' }}>
          
          {checkedResult ? (checkedResult === 'create' ?
            <DoneIcon style={{ color: '#009900', paddingRight: '5px' }} /> : <UpdateIcon style={{ color: '#e69500', paddingRight: '5px' }} />) 
            : <ErrorIcon style={{ color: '#cc0000', paddingRight: '5px' }} />}

          <SportsBasketballIcon style={{ color: checkedResult ? (checkedResult === 'create' ? 'green' : 'orange') : 'black' }}/>
            <strong style={{paddingLeft:'10px'}}>Match</strong>
          </div>
          <div style={{ paddingRight: '10px', paddingLeft: '10px' }}>
            <strong>Saison:</strong> {Saison}
          </div>
          <div style={{ paddingRight: '10px', paddingLeft: '10px' }}>
            <strong>Compétition:</strong> {Competition}
          </div>
          <div style={{ paddingRight: '10px', paddingLeft: '10px' }}>
            <strong>Journée:</strong> {Jour}
          </div>
          {((HomeTeam && HomeTeam.teamName) || HomeTeamName) && ((AwayTeam && AwayTeam.teamName) || AwayTeamName) && (
            <div style={{ paddingRight: '10px', paddingLeft: '10px' }}>
              <strong>Equipes:</strong> {HomeTeam?.teamName || HomeTeamName} - {AwayTeam?.teamName || AwayTeamName}
            </div>
          )}
        </div>    
        {(typeof ImportFlag !== 'undefined' && ImportFlag !== null) ? (
            ImportFlag ? (
                <DoneIcon style={{ color: 'green' }} />
            ) : (
              <div style={{
                'display': 'flex',
                'alignItems': 'center',
                'color': 'red'
                }}>
                    <ErrorIcon style={{ color: 'red' }} />
                    {(typeof ImportErrorMsg !== 'undefined' && ImportErrorMsg !== null) ? (
                        <span>{ImportErrorMsg}</span>
                    ) : null}
                </div>
            )
        ) : null}
      </AccordionSummary>
      <AccordionDetails>
        <div>
          {gameFacts && Object.entries(gameFacts).map(([factKey, factValue]) => (
            
            <Typography key={factKey} style={{display: 'flex', justifyContent: 'space-between'}}>
            
              <Box display="flex" alignItems="center" padding="8px">
              {factValue.checkResult ? (factValue.checkResult === 'create' ?
                    <DoneIcon style={{ color: '#009900', paddingRight: '5px' }} /> : <UpdateIcon style={{ color: '#e69500', paddingRight: '5px' }} />) 
                    : <ErrorIcon style={{ color: '#cc0000', paddingRight: '5px' }} />}
                <SportsIcon style={{ color: factValue.checkResult ? (factValue.checkResult === 'create' ? 'green' : 'orange') : 'black' }} />
                <span style={{ marginLeft: '8px' }}><strong>{factValue?.name}</strong> 
                {factValue?.detail.playerName ? `, joueur : ${factValue.detail.playerName}` : ''}{`, équipe: ${factValue?.detail?.teamName}`}
                </span>
              </Box>
              {(typeof factValue.DBSuccess !== 'undefined' && factValue.DBSuccess !== null) ? (
            factValue.DBSuccess ? (
                <DoneIcon style={{ color: 'green' }} />
            ) : (
              <div style={{
                'display': 'flex',
                'alignItems': 'center',
                'color': 'red'
                }}>
                    <ErrorIcon style={{ color: 'red' }} />
                    {(typeof factValue.DBMessage !== 'undefined' && factValue.DBMessage !== null) ? (
                        <span>{factValue.DBMessage}</span>
                    ) : null}
                </div>
            )
        ) : null}
            </Typography>
          ))}
          {!gameFacts &&
          <div>Aucun faits de jeux à importer</div>
          }
        </div>
        <div>
        { stats && <Typography key={`${Saison}-${Competition}-${Jour}-${HomeTeam}-${AwayTeam}-total`}>
        <Box display="flex" alignItems="center" padding="8px">
        <LibraryAddCheckIcon style={{ color: 'black' }} /><span><strong style={{padding:'10px'}}>TOTAL</strong></span>
            <div style={{display:'flex', justifyContent: 'space-between'}}>
            {Object.entries(stats).map(([type, stat, index]) => (
              <span key={`${stat}-${type}-total`} style={{ marginLeft: '8px', display: 'inline-grid', padding:'15px'}}>
                <strong>{`${type}`}</strong>
                {Object.entries(stat).map(([key, value]) => (
              <span key={`${type}-${key}-${value}-total`} style={{ marginLeft: '8px' }}>
                {`${key} - ${value}`}
              </span>
              ))}
              </span>
            ))}
            </div>
              </Box>
            </Typography>}
        </div>
      </AccordionDetails>
    </Accordion>
  );
};


const CompetitionsAccordionCheckData = ({ competitionData, oddBackground }) => {
  const {
    'competitionName': Competition,
    'season' : Saison,
    'checkResult' : checkedResult,
    'teams': Teams,
    'DBSuccess' : ImportFlag,
    'DBMessage' : ImportErrorMsg

  } = competitionData;

  return (
    <Accordion defaultExpanded={true}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel-content"
        id="panel-header"
        style={{
          backgroundColor: oddBackground ? '#d0d0d075' : 'transparent',
          borderBottom: '2px solid #80808070',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
           <div style={{ paddingRight: '10px', display:'flex', alignItems:'center' }}>

           {checkedResult ? (checkedResult === 'create' ?
            <DoneIcon style={{ color: '#009900', paddingRight: '5px' }} /> : <UpdateIcon style={{ color: '#e69500', paddingRight: '5px' }} />) 
            : <ErrorIcon style={{ color: '#cc0000', paddingRight: '5px' }} />}

          <EmojiEventsIcon style={{ color: checkedResult ? (checkedResult === 'create' ? 'green' : 'orange') : 'black' }}/>
            <strong style={{paddingLeft:'10px'}}>{Competition}</strong>
          </div>
          <div style={{ paddingRight: '10px', paddingLeft: '10px' }}>
          {` (Saison: ${Saison})`}
          </div>
        </div>
        <div>
        {(typeof ImportFlag !== 'undefined' && ImportFlag !== null) ? (
            ImportFlag ? (
                <DoneIcon style={{ color: 'green' }} />
            ) : (
              <div style={{
                'display': 'flex',
                'alignItems': 'center',
                'color': 'red'
                }}>
                    <ErrorIcon style={{ color: 'red' }} />
                    {(typeof ImportErrorMsg !== 'undefined' && ImportErrorMsg !== null) ? (
                        <span>{ImportErrorMsg}</span>
                    ) : null}
                </div>
            )
        ) : null}
                </div>
      </AccordionSummary>
      <AccordionDetails>
        <div>
          {Teams && Object.entries(Teams).map(([teamKey, teamValue]) => (
            <Typography key={teamKey} style={{display: 'flex', justifyContent: 'space-between'}}>
              <Box display="flex" alignItems="center" padding="8px">
                
                {teamValue?.isHome && (<span style={{ paddingRight: '10px', display: 'flex', alignItems: 'center' }}>
                  {teamValue.checkResult ? (teamValue.checkResult === 'create' ?
                    <DoneIcon style={{ color: '#009900', paddingRight: '5px' }} /> : <UpdateIcon style={{ color: '#e69500', paddingRight: '5px' }} />) 
                    : <ErrorIcon style={{ color: '#cc0000', paddingRight: '5px' }} />}
                  <GroupsIcon style={{ color: teamValue.checkResult ? (teamValue.checkResult === 'create' ? 'green' : 'orange') : 'black' }}/><strong style={{ paddingLeft: '10px'}}>Equipe Locale:</strong></span>)}
                
                {teamValue?.isAway && (<span style={{ paddingRight: '10px', display: 'flex', alignItems: 'center' }}>
                {teamValue.checkResult ? (teamValue.checkResult === 'create' ?
                    <DoneIcon style={{ color: '#009900', paddingRight: '5px' }} /> : <UpdateIcon style={{ color: '#e69500', paddingRight: '5px' }} />) 
                    : <ErrorIcon style={{ color: '#cc0000', paddingRight: '5px' }} />}
                  <GroupsIcon style={{ color: teamValue.checkResult ? (teamValue.checkResult === 'create' ? 'green' : 'orange') : 'black' }} /><strong style={{ paddingLeft: '10px'}}>Equipe Visiteur:</strong></span>)}
                
                <span style={{ marginLeft: '8px' }}>{`${teamValue?.teamName}`}</span>
              </Box>
              {(typeof teamValue.DBSuccess !== 'undefined' && teamValue.DBSuccess !== null) ? (
            teamValue.DBSuccess ? (
                <DoneIcon style={{ color: 'green' }} />
            ) : (
                <div style={{
                  'display': 'flex',
                  'alignItems': 'center',
                  'color': 'red'
                  }}>
                    <ErrorIcon style={{ color: 'red' }} />
                    {(typeof teamValue.DBMessage !== 'undefined' && teamValue.DBMessage !== null) ? (
                        <span>{teamValue.DBMessage}</span>
                    ) : null}
                </div>
            )
        ) : null}
            </Typography>
          ))}
        </div>
      </AccordionDetails>
    </Accordion>
  );
};


const TeamsAccordionCheckData = ({ teamData, oddBackground }) => {
  const {
    'teamName': TeamName,
    'checkResult' : checkedResult,
    'players': Players,
    'DBSuccess' : ImportFlag,
    'DBMessage' : ImportErrorMsg
  } = teamData;

  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel-content"
        id="panel-header"
        style={{
          backgroundColor: oddBackground ? '#d0d0d075' : 'transparent',
          borderBottom: '2px solid #80808070',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div style={{ paddingRight: '10px', display:'flex', alignItems:'center' }}>
          {checkedResult ? (checkedResult === 'create' ?
            <DoneIcon style={{ color: '#009900', paddingRight: '5px' }} /> : <UpdateIcon style={{ color: '#e69500', paddingRight: '5px' }} />) 
            : <ErrorIcon style={{ color: '#cc0000', paddingRight: '5px' }} />}
          <GroupsIcon style={{ color: checkedResult ? (checkedResult === 'create' ? 'green' : 'orange') : 'black' }}/>
            <strong style={{paddingLeft:'10px'}}>{TeamName}</strong>
          </div>
          <div style={{ paddingRight: '10px', paddingLeft: '10px' }}>
            {Players && Object.entries(Players) && <span>{` (${Object.entries(Players).length} joueurs)`}</span>}
            {!Players && <span>{` (0 joueurs)`}</span>}
          </div>
        </div>
        {(typeof ImportFlag !== 'undefined' && ImportFlag !== null) ? (
            ImportFlag ? (
                <DoneIcon style={{ color: 'green' }} />
            ) : (
              <div style={{
                'display': 'flex',
                'alignItems': 'center',
                'color': 'red'
                }}>
                    <ErrorIcon style={{ color: 'red' }} />
                    {(typeof ImportErrorMsg !== 'undefined' && ImportErrorMsg !== null) ? (
                        <span>{ImportErrorMsg}</span>
                    ) : null}
                </div>
            )
        ) : null}
      </AccordionSummary>
      <AccordionDetails>
        <div>
          {Players && Object.entries(Players).map(([playerKey, playerValue]) => (
            <Typography key={playerKey} style={{display: 'flex', justifyContent: 'space-between'}}>
              <Box display="flex" alignItems="center" padding="8px">
              {playerValue.checkResult ? (playerValue.checkResult === 'create' ?
                    <DoneIcon style={{ color: '#009900', paddingRight: '5px' }} /> : <UpdateIcon style={{ color: '#e69500', paddingRight: '5px' }} />) 
                    : <ErrorIcon style={{ color: '#cc0000', paddingRight: '5px' }} />}
              <PersonIcon style={{ color: playerValue.checkResult ? (playerValue.checkResult === 'create' ? 'green' : 'orange') : 'black' }} />
                <span style={{ marginLeft: '8px' }}>{`${playerValue.firstName} ${playerValue.lastName}`}</span>
              </Box>
              {(typeof playerValue.DBSuccess !== 'undefined' && playerValue.DBSuccess !== null) ? (
            playerValue.DBSuccess ? (
                <DoneIcon style={{ color: 'green' }} />
            ) : (
              <div style={{
                'display': 'flex',
                'alignItems': 'center',
                'color': 'red'
                }}>
                    <ErrorIcon style={{ color: 'red' }} />
                    {(typeof playerValue.DBMessage !== 'undefined' && playerValue.DBMessage !== null) ? (
                        <span>{playerValue.DBMessage}</span>
                    ) : null}
                </div>
            )
        ) : null}
            </Typography>
          ))}
        </div>
      </AccordionDetails>
    </Accordion>
  );
};


function generateTechnicalId() {
  const timestamp = new Date().getTime();
  const random = Math.floor(Math.random() * 1000); // Valeur aléatoire pour éviter les conflits en cas de création simultanée

  return `${timestamp}-${random}`;
}


const formatExcelDataToMongoModel = (excelData, provider, gamefactTypeMapping, existingMatchData) => {
  const formattedData = [];

  excelData.forEach((match) => {
    // Générer un ID technique pour mapper les erreurs ou avertissements, émis par l'appel serveur (vérification des doublons)
    match.json_id = generateTechnicalId();
    let formattedMatch = {};
    formattedMatch.json_id = match.json_id;
    formattedMatch.provider = provider;

    formattedMatch.playerFirstName = match['Prénom Joueur'];
    formattedMatch.playerTeamName = match['Equipe Joueur'];
    formattedMatch.playerLastName = match['Nom Joueur']; 
    formattedMatch.playerNumber = match['Numéro Joueur'];

    if (existingMatchData){
      formattedMatch.matchId = existingMatchData._id;
      formattedMatch.competitionId = existingMatchData.competition._id;
      formattedMatch.competitionName = existingMatchData.competition.name;
      formattedMatch.season = existingMatchData.competition.season;
      formattedMatch.day = existingMatchData.day;
      formattedMatch.homeTeamId = existingMatchData.homeTeam._id;
      formattedMatch.awayTeamId = existingMatchData.awayTeam._id;
      formattedMatch.homeTeamName = existingMatchData.homeTeam.name;
      formattedMatch.awayTeamName = existingMatchData.awayTeam.name;
    } else {
      formattedMatch.season = match['Saison'];
      formattedMatch.competitionName = match['Compétition'];
      formattedMatch.day = match['Journée'];
      formattedMatch.homeTeamName = match['Equipe domicile'];
      formattedMatch.awayTeamName = match['Equipe visiteur'];
    }

    //Handle minutes played to create replacement out GF
    formattedMatch.minutes = match['Minutes'];

    let gameFacts = {};

    Object.entries(match.gameFacts)
      .filter(([gameFactName, GamefactNumberToCreate]) => GamefactNumberToCreate && GamefactNumberToCreate>0)
        .forEach(([gameFactName, GamefactNumberToCreate]) => {

            if (GamefactNumberToCreate && GamefactNumberToCreate>0){
            let gfType = gamefactTypeMapping.get(gameFactName);

            let formattedGameFact = {
              detail: {
                period: 0,
                timer: 0,
                player: {
                  lastName: match['Nom Joueur'],
                  firstName: match['Prénom Joueur'],
                },
                team: {
                  teamName: match['Equipe Joueur'],
                },
              },
              type: gfType,
            };
              gameFacts[gameFactName] = { nbToCreate: GamefactNumberToCreate, data: formattedGameFact };
            }
          });

    formattedMatch.gameFacts = gameFacts;

    formattedData.push(formattedMatch);
  });

  return formattedData;
};


const MatchesBasketCSV = ({ importOption, provider, discipline, match }) => {

    const [loading, setLoading] = useState(false);
    const [showPlayerAccordion, setShowPlayerAccordion] = useState(false);
    const [showGamefactsAccordionCheckData, setShowGamefactsAccordionCheckData] = useState(false);
    
    const [excelData, setExcelData] = useState(null);
    const [pastedTableData, setPastedTableData] = useState(null);
    const [checkedData, setCheckedData] = useState(null);
    const [isImportedData, setIsImportedData] = useState(false);
    const [columnMappings, setColumnMappings] = useState({});
    const [mappedColumns, setMappedColumns] = useState({});
    const [isMappingValid, setIsMappingValid] = useState(false);
    const [isColumnMappingModalOpen, setIsColumnMappingModalOpen] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [workbook, setWorkbook] = useState(null);
    const [headerRow, setHeaderRow] = useState([]);
    const [importSummary, setImportSummary] = useState(null);

    const createGamefactTechnicalMapping = () => {

      let sportGamefacts = new Map();
    
      if (discipline === 'basket'){

      sportGamefacts.set('Lancer franc tenté', GAME_FACT_BASKET_FREETHROW_TRY);
      sportGamefacts.set('Lancer franc réussi', GAME_FACT_BASKET_FREETHROW_SUCCEEDED);
      sportGamefacts.set('2 points tenté', GAME_FACT_BASKET_TWOPOINTS_TRY);
      sportGamefacts.set('2 points réussi', GAME_FACT_BASKET_TWOPOINTS_SUCCEEDED);
      sportGamefacts.set('3 points tenté', GAME_FACT_BASKET_THREEPOINTS_TRY);
      sportGamefacts.set('3 points réussi', GAME_FACT_BASKET_THREEPOINTS_SUCCEEDED);

      sportGamefacts.set('Faute', GAME_FACT_BASKET_FAULT);
      sportGamefacts.set('Faute technique', GAME_FACT_BASKET_TECHNICAL);
      sportGamefacts.set('Temps mort', GAME_FACT_BASKET_TIMEOUT);
      sportGamefacts.set('Rebond défensif', GAME_FACT_BASKET_DEFENSIVE_REBOUND);
      sportGamefacts.set('Rebond offensif', GAME_FACT_BASKET_OFFENSIVE_REBOUND);
      sportGamefacts.set('Faute subie', GAME_FACT_BASKET_SUFFERED_FAULT);
      sportGamefacts.set('Contre', GAME_FACT_BASKET_COUNTER);
      sportGamefacts.set('Contre subi', GAME_FACT_BASKET_SUFFERED_COUNTER);
      sportGamefacts.set('Passe décisive', GAME_FACT_BASKET_DECISIVE_PASS);

      } 
      else if (discipline === 'soccer'){

        sportGamefacts.set('But tenté', GAME_FACT_SOCCER_BUT_TRY);
        sportGamefacts.set('But réussi', GAME_FACT_SOCCER_BUT_SUCCEEDED);
        sportGamefacts.set('Penalité tentée', GAME_FACT_SOCCER_PENALTY_TRY );
        sportGamefacts.set('Penalité réussie', GAME_FACT_SOCCER_PENALTY_SUCCEEDED );
        sportGamefacts.set('Tir au but tenté', GAME_FACT_SOCCER_SHOOTOUTPENALTY_TRY );
        sportGamefacts.set('Tir au but réussi', GAME_FACT_SOCCER_SHOOTOUTPENALTY_SUCCEEDED );
        sportGamefacts.set('Tir', GAME_FACT_SOCCER_SHOT);
        sportGamefacts.set('Faute', GAME_FACT_SOCCER_FAULT );
        sportGamefacts.set('Carton jaune', GAME_FACT_SOCCER_YELLOWCARD );
        sportGamefacts.set('Carton rouge', GAME_FACT_SOCCER_REDCARD  );

        }
        else if (discipline === 'rugby'){

          sportGamefacts.set('Drop tenté', GAME_FACT_DROP_TRY);
          sportGamefacts.set('Drop réussi', GAME_FACT_DROP_SUCCEEDED);
          sportGamefacts.set('Transformation tentée', GAME_FACT_TRANSFORMATION_TRY);
          sportGamefacts.set('Transformation réussie', GAME_FACT_TRANSFORMATION_SUCCEEDED);
          sportGamefacts.set('Penalité tentée', GAME_FACT_PENALITE_TRY );
          sportGamefacts.set('Penalité réussie', GAME_FACT_PENALITE_SUCCEEDED );
          sportGamefacts.set('Essai', GAME_FACT_ESSAI );
          sportGamefacts.set('Tir au but tenté', GAME_FACT_SHOOTOUTPENALTY_TRY );
          sportGamefacts.set('Tir au but réussi', GAME_FACT_SHOOTOUTPENALTY_SUCCEEDED );
          sportGamefacts.set('Faute', GAME_FACT_FAULT );
          sportGamefacts.set('Carton jaune', GAME_FACT_YELLOWCARD);
          sportGamefacts.set('Carton rouge', GAME_FACT_REDCARD);


          }
          else if (discipline === 'handball'){

            sportGamefacts.set('But tenté', GAME_FACT_HANDBALL_GOAL_TRY );
            sportGamefacts.set('But réussi', GAME_FACT_HANDBALL_GOAL_SUCCEEDED );

            sportGamefacts.set('Tir au but tenté', GAME_FACT_HANDBALL_SHOOTOUT_TRY );
            sportGamefacts.set('Tir au but réussi', GAME_FACT_HANDBALL_SHOOTOUT_SUCCEEDED );
           
            sportGamefacts.set('Penalty tenté', GAME_FACT_HANDBALL_PENALTY_TRY );
            sportGamefacts.set('Penalty réussi', GAME_FACT_HANDBALL_PENALTY_SUCCEEDED );

            sportGamefacts.set('Avertissement', GAME_FACT_HANDBALL_YELLOWCARD);
            sportGamefacts.set('Disqualification', GAME_FACT_HANDBALL_REDCARD);
            sportGamefacts.set('Exclusion temporaire', GAME_FACT_HANDBALL_TWOMIN_SUSPENSION);
            sportGamefacts.set('Temps mort', GAME_FACT_HANDBALL_TIMEOUT);
            sportGamefacts.set('Balle perdue', GAME_FACT_HANDBALL_TURNOVER);

            }
    
      return sportGamefacts;
    
    }

    // Extract common columns and data // removed , 'Points' for now
    let commonColumnsCreation = ['Compétition', 'Saison', 'Journée', 'Equipe domicile', 'Equipe visiteur', 'Numéro Joueur', 'Nom Joueur', 'Prénom Joueur','Equipe Joueur', 'Minutes'];
    if (match) {
      // Colonnes à supprimer si match existe
      const columnsToRemove = ['Compétition', 'Saison', 'Journée', 'Equipe domicile', 'Equipe visiteur'];
      // Filtrer les colonnes pour exclure celles à supprimer
      commonColumnsCreation = commonColumnsCreation.filter(column => !columnsToRemove.includes(column));
    }
    const commonColumns = commonColumnsCreation;
    //removed , 'Points' for now
    const requiredColumns = commonColumnsCreation.filter(column => !['Minutes'].includes(column));

    const gamefactTypeMapping = createGamefactTechnicalMapping();

    const handleNextAction = async () => {

      setShowPlayerAccordion(false);
      setShowGamefactsAccordionCheckData(false)

         // Show loading indicator
         setLoading(true);
         const formattedData = formatExcelDataToMongoModel(excelData, provider, gamefactTypeMapping, match);

         try {
          // TODO add template name & discipline from parent MatchesCSV
          const { data } = await checkImportMatches(formattedData,discipline,'DSAS');
          setCheckedData({matches: data.matches, competitions: data.competitions, teams: data.teams});
      } catch (error) {
          console.error('error', error, error.message);
          //TODO setResponse([error.message]);
      }
         setLoading(false);
         setShowGamefactsAccordionCheckData(true);
    };


    const handleImportAction = async () => {

      setShowPlayerAccordion(false);
      setShowGamefactsAccordionCheckData(false)
      
         // Show loading indicator
         setLoading(true);

         try {
          const { data } = await importMatches({matches: checkedData.matches, competitions: checkedData.competitions, teams: checkedData.teams},discipline,'DSAS');
          setCheckedData({matches: data.matches, competitions: data.competitions, teams: data.teams, message: data.message});
          setImportSummary(data.importSummary);
          setIsImportedData(true);
      } catch (error) {
          console.error('error', error, error.message);
          //TODO setResponse([error.message]);
      }
         setLoading(false);
         setShowGamefactsAccordionCheckData(true);
    };


    const handleExcelData = () => {
      setShowPlayerAccordion(true);
      setShowGamefactsAccordionCheckData(false)
    };
    
  
    const openColumnMappingModal = () => {
      setIsColumnMappingModalOpen(true);
      setShowPlayerAccordion(false);
      setShowGamefactsAccordionCheckData(false)
    };
  
    const handleColumnMappingChange = (newMappings, newIndexMappings, isValid) => {
      // Set mapping
      setColumnMappings(newMappings);
      setMappedColumns(newIndexMappings);
      // Validation state update
      setIsMappingValid(isValid);
      // Close the modal after applying mappings
      setIsColumnMappingModalOpen(false); 
      setShowPlayerAccordion(true);
    };

    const onDrop = (acceptedFiles) => {
      const file = acceptedFiles[0];
      const reader = new FileReader();
  
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        setWorkbook(workbook);

        // Data is in the first sheet (to confirm)
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        
        // Extract the header row
        const headerRow = XLSX.utils.sheet_to_json(sheet, { header: 1 })[0];
        setHeaderRow(headerRow);
  
        // Open the column mapping modal before processing the data
        openColumnMappingModal();
      };
  
      reader.readAsArrayBuffer(file);
    };

    const onPaste = (pastedTableData) => {

      if (pastedTableData){
        const headerRow = pastedTableData[0];
        setHeaderRow(headerRow);
        openColumnMappingModal();
        setPastedTableData(pastedTableData);
      }
  
    };

  const processData = (sheet,isCSV) => {
    
  const gamefactsColumns = Array.from(gamefactTypeMapping.keys());
  const data = isCSV ? XLSX.utils.sheet_to_json(sheet, { header: 1, blankrows: false, defval: '' }) : sheet;

  const processedData = data.slice(1).map((row) => {
  const commonData = {};
  const gameFacts = {};

    commonColumns.forEach((col, index) => {
      commonData[col] = row[mappedColumns[col]];
    });

    gamefactsColumns.forEach((col, index) => {
      gameFacts[col] = row[mappedColumns[col]];
    });

    return {
      ...commonData,
      gameFacts,
    };
  });

  return processedData;
  };

  useEffect(() => {
    // Process the file if mappings are present and the modal is closed
    if (Object.keys(mappedColumns).length > 0 && !isColumnMappingModalOpen && !isProcessing && workbook) {
      setIsProcessing(true);

      // Process sheet data
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];

      const processedData = processData(sheet, true);

      setExcelData(processedData);
      setIsProcessing(false);
    }
    // Process the pasted data if mappings are present and the modal is closed
    if (Object.keys(mappedColumns).length > 0 && !isColumnMappingModalOpen && !isProcessing && pastedTableData) {
      setIsProcessing(true);

      const processedData = processData(pastedTableData, false);

      setExcelData(processedData);
      setIsProcessing(false);
    }
  }, [mappedColumns, isColumnMappingModalOpen, isProcessing, workbook]);


const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <div>
      {importOption ==='dropzone' && !isColumnMappingModalOpen && !showPlayerAccordion && !showGamefactsAccordionCheckData && !loading && (
      <div {...getRootProps()} style={dropzoneStyles}>
        <input {...getInputProps()} />
        <p>Glissez-déposez un fichier Excel ici, ou cliquez pour en sélectionner un</p>
      </div>
      )}
      {importOption ==='copy-paste' && !isColumnMappingModalOpen && !showPlayerAccordion && !showGamefactsAccordionCheckData && !loading && (
      <div>
        <PasteTableComponent onProcessData={onPaste}/>
      </div>
      )}

      {/* Column Mapping */}
      {isColumnMappingModalOpen && (
        <ColumnMappingComponent
          commonColumns={commonColumns}
          gamefactsColumns={Array.from(createGamefactTechnicalMapping().keys())}
          requiredColumns={requiredColumns}
          onColumnMappingChange={handleColumnMappingChange}
          prevColumnMapping={columnMappings}
          prevMappedColumns={mappedColumns}
          headerRow={headerRow}
          showInfoMsg={true}
        />
      )}

      {/* Loading indicator */}
      {loading && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px' }}>
          <CircularProgress />
        </div>
      )}

      {showPlayerAccordion && (
        <div style={{display: 'flex',
          justifyContent: 'space-between', paddingTop:'20px', paddingBottom:'20px'}}>
          <button  style={{
            padding: '10px',
            borderRadius: '5px',
            background: '#0A76B9',
            color: 'white',
            cursor: 'pointer'
          }} onClick={() => openColumnMappingModal()}>Modifier le mapping</button>
          <button  style={{
            padding: '10px',
            borderRadius: '5px',
            background: '#0A76B9',
            color: 'white',
            cursor: 'pointer'
          }} onClick={handleNextAction}>Lancer la vérification</button>
        </div>
      )}

      {showGamefactsAccordionCheckData && !isImportedData && (
        <div style={{display: 'flex',
          justifyContent: 'space-between', paddingTop:'20px', paddingBottom:'20px'}}>
          <button  style={{
            padding: '10px',
            borderRadius: '5px',
            background: '#0A76B9',
            color: 'white',
            cursor: 'pointer'
          }} onClick={() => handleExcelData()}>Retour</button>
          <button  style={{
            padding: '10px',
            borderRadius: '5px',
            background: '#0A76B9',
            color: 'white',
            cursor: 'pointer'
          }} onClick={handleImportAction}>Importer les données</button>
        </div>
      )}

 
      {/*Step 1 - Sheet read result*/}
      {showPlayerAccordion && excelData && (
        <div style={{ marginTop: '20px', marginBottom: '20px' }}>
          <div style={{ marginBottom: '30px' }}>
            <h2 style={{ marginBottom: '20px' }}>{'Aperçu de lecture'}</h2>
            <span>
              Ceci est un aperçu de la lecture de votre fichier ligne par ligne. Cliquez sur "lancer la vérification" pour commencer le traitement et comparer l'existant en base de données.
            </span>
          </div>
          {excelData.map((player, index) => (
            <PlayerAccordion key={index} playerData={player} oddBackground={index % 2 === 1} />
          ))}
        </div>
      )}

        {/*Step 2 - First DB check for import & logic*/}
        {!isImportedData && checkedData && (<div style={{ marginTop: '20px', marginBottom: '20px' }}>
              <h2 style={{ marginBottom: '20px' }}>{'Traitement des données'}</h2>
              <span>
                Ceci est un aperçu du traitement de vos données, telles qu'elles seront importées. Cliquez sur "importer les données" pour procéder à l'import en base de données.
              </span>
        </div>)}

        {isImportedData && checkedData && importSummary && (
        <ImportResume importSummary={importSummary} />
      )}

      {/*Légende résultat de check / imports*/}
      {!isImportedData && showGamefactsAccordionCheckData && checkedData &&
        <Legend/>}


      {/*Compétitions à vérifier pour import*/}
      {showGamefactsAccordionCheckData && checkedData && checkedData.competitions &&
        <div style={{paddingTop: '25px', paddingBottom: '25px'}}>
          <div>
            <h3>Compétitions</h3>
          </div>
          <div style={{paddingTop: '10px'}}>
            {Object.entries(checkedData.competitions).map(([competitionKey, competitionData], index) => (
              <CompetitionsAccordionCheckData key={index} competitionData={competitionData} oddBackground={index % 2 === 1} />
            ))}
          </div>
        </div>
      }
     
       {/*Equipes et joueurs à vérifier pour import*/}
       {showGamefactsAccordionCheckData && checkedData && checkedData.teams &&
        <div style={{paddingTop: '25px', paddingBottom: '25px'}}>
          <div>
            <h3>Equipes et joueurs</h3>
          </div>
          <div style={{paddingTop: '10px'}}>
            {Object.entries(checkedData.teams).map(([teamKey, teamData], index) => (
              <TeamsAccordionCheckData key={index} teamData={teamData} oddBackground={index % 2 === 1} />
            ))}
          </div>
        </div>
        }
   
    {/*Matchs et faits de jeux à vérifier pour import*/}
      {showGamefactsAccordionCheckData && checkedData && checkedData.matches &&
        <div style={{paddingTop: '25px', paddingBottom: '25px'}}>
            <div>
              <h3>Matchs et faits de jeux</h3>
            </div>
            <div style={{paddingTop: '10px'}}>
              {checkedData.matches.map((match, index) => (
                <GamefactsAccordionCheckData key={index} playerData={match} oddBackground={index % 2 === 1} />
              ))}
            </div>
        </div>
      }
      
    </div>
  );
      }


export default MatchesBasketCSV;